import { TPatchGameComment, TQueryWish } from '@src/modules'
import { LANGUAGE_DEFAULT } from '@src/configs/const.config'

import { request } from './config'

export const getListWish = (params: TQueryWish, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'wish', method: 'GET', params }, { token, lang })
export const removeWishById = (id: string) => request({ url: `wish/${id}`, method: 'DELETE' })
export const patchWishById = (id: string, data: TPatchGameComment) =>
  request({ url: `wish/${id}`, method: 'PATCH', data })
export const exportWishList = (params: TQueryWish, token?: string, lang = LANGUAGE_DEFAULT) =>
  request(
    {
      url: 'wish/export-xlsx',
      method: 'GET',
      params,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    },
    { token, lang },
  )
